import { render, staticRenderFns } from "./WidgetTemplate.vue?vue&type=template&id=4c38e3b6&"
import script from "./WidgetTemplate.vue?vue&type=script&lang=js&"
export * from "./WidgetTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetTemplate.vue"
export default component.exports